/*jshint esversion: 9 */
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';
//----------------------------------------------------------------------
export const TRANSACTION_START = 'TRANSACTION_START';
export const TRANSACTION_SUCCESS = 'TRANSACTION_SUCCESS';
export const TRANSACTION_FAIL = 'TRANSACTION_FAIL';
//----------------------------------------------------------------------
export const FETCH_INCIDENTTYPE_LIST_START = 'FETCH_INCIDENTTYPE_LIST_START';
export const FETCH_INCIDENTTYPE_LIST_SUCCESS = 'FETCH_INCIDENTTYPE_LIST_SUCCESS';
export const FETCH_INCIDENTTYPE_LIST_FAIL = 'FETCH_CONNECTION_LIST_FAIL';
//----------------------------------------------------------------------
export const ADD_TO_CUSTOMTEXT_ARRAY = 'ADD_TO_CUSTOMTEXT_ARRAY';
export const CLEAR_CUSTOMTEXT_LIST = 'CLEAR_CUSTOMTEXT_LIST';
export const FETCH_CUSTOMTEXT_LIST_START = 'FETCH_CUSTOMTEXT_LIST_START';
export const FETCH_CUSTOMTEXT_LIST_SUCCESS = 'FETCH_CUSTOMTEXT_LIST_SUCCESS';
export const FETCH_CUSTOMTEXT_LIST_FAIL = 'FETCH_CUSTOMTEXT_LIST_FAIL';
export const SET_CUSTOMTEXT_ARRAY = 'SET_CUSTOMTEXT_ARRAY';
//----------------------------------------------------------------------
export const CLEAR_INCIDENT_DETAILS = 'CLEAR_INCIDENT_DETAILS';
export const FETCH_INCIDENT_DETAILS_START = 'FETCH_INCIDENT_DETAILS_START';
export const FETCH_INCIDENT_DETAILS_SUCCESS = 'FETCH_INCIDENT_DETAILS_SUCCESS';
export const FETCH_INCIDENT_DETAILS_FAIL = 'FETCH_INCIDENT_DETAILS_FAIL';
export const SET_SHARED_INCIDENT_DETAILS = "SET_SHARED_INCIDENT_DETAILS";
//----------------------------------------------------------------------
export const ADD_TO_REQUIREDFIELD_ARRAY = 'ADD_TO_REQUIREDFIELD_ARRAY';
export const CLEAR_REQUIREDFIELD_LIST = 'CLEAR_REQUIREDFIELD_LIST';
export const FETCH_REQUIREDFIELD_LIST_START = 'FETCH_REQUIREDFIELD_LIST_START';
export const FETCH_REQUIREDFIELD_LIST_SUCCESS = 'FETCH_REQUIREDFIELD_LIST_SUCCESS';
export const FETCH_REQUIREDFIELD_LIST_FAIL = 'FETCH_REQUIREDFIELD_LIST_FAIL';
export const SET_REQUIREDFIELD_ARRAY = 'SET_REQUIREDFIELD_ARRAY';
//----------------------------------------------------------------------
export const FETCH_DEFAULTREQUIREDFIELD_LIST_START = 'FETCH_DEFAULTREQUIREDFIELD_LIST_START';
export const FETCH_DEFAULTREQUIREDFIELD_LIST_SUCCESS = 'FETCH_DEFAULTREQUIREDFIELD_LIST_SUCCESS';
export const FETCH_DEFAULTREQUIREDFIELD_LIST_FAIL = 'FETCH_DEFAULTREQUIREDFIELD_LIST_FAIL';
//----------------------------------------------------------------------
export const CLEAR_VALIDCODE_LIST = 'CLEAR_VALIDCODE_LIST';
export const FETCH_VALIDCODE_LISTS_START = 'FETCH_VALIDCODE_LISTS_START';
export const FETCH_VALIDCODE_LISTS_SUCCESS = 'FETCH_VALIDCODE_LISTS_SUCCESS';
export const FETCH_VALIDCODE_LISTS_FAIL = 'FETCH_CONNECTION_LIST_FAIL';
//----------------------------------------------------------------------
export const FETCH_MULTIPLE_VALIDCODE_LISTS_START = 'FETCH_MULTIPLE_VALIDCODE_LISTS_START';
export const FETCH_MULTIPLE_VALIDCODE_LISTS_SUCCESS = 'FETCH_MULTIPLE_VALIDCODE_LISTS_SUCCESS';
export const FETCH_MULTIPLE_VALIDCODE_LISTS_FAIL = 'FETCH_MULTIPLE_VALIDCODE_LISTS_FAIL';
//----------------------------------------------------------------------
export const CLEAR_TRANSACTION_RESULT = 'CLEAR_TRANSACTION_RESULT';
export const CLEAR_TRANS_DESC = 'CLEAR_TRANS_DESC';
//----------------------------------------------------------------------
export const FETCH_CONFIGURATION_START = 'FETCH_CONFIGURATION_START';
export const FETCH_CONFIGURATION_SUCCESS = 'FETCH_CONFIGURATION_SUCCESS';
export const FETCH_CONFIGURATION_FAIL = 'FETCH_CONFIGURATION_FAIL';
//----------------------------------------------------------------------
export const SET_CONFIGURATION_DEFAULTS = 'SET_CONFIGURATION_DEFAULTS';
export const SET_AGENCYCODE = "SET_AGENCYCODE";
export const SET_SERVERINFO = 'SET_SERVERINFO';
export const SET_INCIDENTTYPEDATA = 'SET_INCIDENTTYPEDATA';
//
export const ADD_TO_NAME_ARRAY = 'ADD_TO_NAME_ARRAY';
export const DELETE_FROM_NAME_ARRAY = 'DELETE_FROM_NAME_ARRAY';
export const SET_NAME_ARRAY = 'SET_NAME_ARRAY';
export const SET_NAME_SELECT_FIELDLIST = 'SET_NAME_SELECT_FIELDLIST';
export const SET_NAME_TEXT_FIELDLIST = 'SET_NAME_TEXT_FIELDLIST';
//
export const ADD_TO_ATTACHMENT_ARRAY = 'ADD_TO_ATTACHMENT_ARRAY';
export const DELETE_FROM_ATTACHMENT_ARRAY = 'DELETE_FROM_ATTACHMENT_ARRAY';
export const SET_ATTACHMENT_ARRAY = 'SET_ATTACHMENT_ARRAY';
export const SET_ATTACHMENT_SELECT_FIELDLIST = 'SET_ATTACHMENT_SELECT_FIELDLIST';
export const SET_ATTACHMENT_TEXT_FIELDLIST = 'SET_ATTACHMENT_TEXT_FIELDLIST';
//
export const ADD_TO_PERSON_ARRAY = 'ADD_TO_PERSON_ARRAY';
export const DELETE_FROM_PERSON_ARRAY = 'DELETE_FROM_PERSON_ARRAY';
export const SET_PERSON_ARRAY = 'SET_PERSON_ARRAY';
export const SET_PERSON_SELECT_FIELDLIST = 'SET_PERSON_SELECT_FIELDLIST';
export const SET_PERSON_TEXT_FIELDLIST = 'SET_PERSON_TEXT_FIELDLIST';
//
export const ADD_TO_PROPERTY_ARRAY = 'ADD_TO_PROPERTY_ARRAY';
export const DELETE_FROM_PROPERTY_ARRAY = 'DELETE_FROM_PROPERTY_ARRAY';
export const SET_PROPERTY_ARRAY = 'SET_PROPERTY_ARRAY';
export const SET_PROPERTY_SELECT_FIELDLIST = 'SET_PROPERTY_SELECT_FIELDLIST';
export const SET_PROPERTY_TEXT_FIELDLIST = 'SET_PROPERTY_TEXT_FIELDLIST';
//
export const ADD_TO_VEHICLE_ARRAY = 'ADD_TO_VEHICLE_ARRAY';
export const DELETE_FROM_VEHICLE_ARRAY = 'DELETE_FROM_VEHICLE_ARRAY';
export const SET_VEHICLE_ARRAY = 'SET_VEHICLE_ARRAY';
export const SET_VEHICLE_SELECT_FIELDLIST = 'SET_VEHICLE_SELECT_FIELDLIST';
export const SET_VEHICLE_TEXT_FIELDLIST = 'SET_VEHICLE_TEXT_FIELDLIST';
//----------------------------------------------------------------------
export const FETCH_REPORT_LIST_START = 'FETCH_REPORT_LIST_START';
export const FETCH_REPORT_LIST_SUCCESS = 'FETCH_REPORT_LIST_SUCCESS';
export const FETCH_REPORT_LIST_FAIL = 'FETCH_REPORT_LIST_FAIL';
//----------------------------------------------------------------------
export const REPORT_START = 'REPORT_START';
export const REPORT_SUCCESS = 'REPORT_SUCCESS';
export const REPORT_FAIL = 'REPORT_FAIL';
export const CLEAR_REPORT_RESULT = 'CLEAR_REPORT_RESULT';
//----------------------------------------------------------------------
export const UPLOAD_FILE_START = 'UPLOAD_FILE_START';
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS';
export const UPLOAD_FILE_FAIL = 'UPLOAD_FILE_FAIL';
export const CLEAR_UPLOAD_RESULT = 'CLEAR_UPLOAD_RESULT';
//----------------------------------------------------------------------
export const CLEAR_WEBAGENCY_LIST = 'CLEAR_WEBAGENCY_LIST';
//----------------------------------------------------------------------
